<template>
<div class="main">
  <BreadCrumb :data="breadCrumb" />

  <b-card no-body>
    <b-spinner v-if="isLoading" variant="primary"></b-spinner>
    <form-wizard
      ref="faultWizzard"
      title=""
      subtitle=""
      color="#007bff"
      @on-loading="setLoading"
      @on-complete="addImage"
      backButtonText="Geri"
      nextButtonText="İleri"
      finishButtonText="Bitir">
    <tab-content 
      title="Genel Bilgiler"
      icon="ti-info-alt"
      :before-change="postFault">
        <Form ref="Info" :forms="faultForm" />
    </tab-content>
    <tab-content 
      style="min-height: 500px"
      title="Fotoğraf Ekleme"
      icon="ti-image">
        <Form ref="File" :forms="faultImgForm" />
    </tab-content>
  </form-wizard>
  </b-card>
  <Modals :open="modalOpen" :modalEvent="openModal" :modalProps="modalProps" :form="currentForm"
      :modalName="modalName"
    />
</div>
</template>

<script>
import BreadCrumb from "@/components/BreadCrumb";
import FaultSupportForm from './components/AddFaultSupportForm'
import Form from '@/components/Form'
import {prepareRequestData} from '@/assets/js/custom.js'
import Forms from './forms'
import Modals from "./modals/";

const breadCrumb = [
  { label: "Stoklar", url: "/Stock/List" },
  { label: "Arıza Destekleri", url: "/Stock/FaultSupports" },
  { label: "Ekle", url: "/Stock/FaultSupports/Add" }
]

export default {
  name: 'AddFaultSupport',
  components: {
    BreadCrumb,
    FaultSupportForm,
    Form,
    Modals
  },
  data() {
    return {
      breadCrumb,
      isLoading: false,
      faultForm: Forms.Fault,
      faultImgForm: Forms.FaultImage,
      modalProps: {}, modalName: "", modalOpen: false, currentForm: "faultSupports"
    }
  },
  computed: {
    status() {
      return this.$store.getters.getStockStatus
    },
    faultSupport() {
      return this.$store.getters.faultSupportsList[0]
    },

  },
  methods: {
    setLoading(val) {
      this.isLoading = val
    },
    openModal(state, modal, props){
      this.modalOpen = state
      if(state){
        this.modalName = modal
        this.modalProps = props
      }
    },
    async postFault() {
      return new Promise((res, rej) => {
        this.$refs.Info.$refs.Form.validate()
        .then(async success => {
          if(success) {
            let data = prepareRequestData(this.faultForm,this.$refs.Info.formData)
            await this.$store.dispatch('addFaultSupport', data)
            if(this.status.status == 'Success') {
              const filter = { productSerialNumber: data.serial_number }
              await this.$store.dispatch('faultsupports_get', filter)
              return res(true)
            }else if(this.status.status == 'Error' && this.status.code == 471){
              this.$bvToast.toast('Takip dışı bir ürün üzerinde işlem yapıyorsunuz. Lütfen önce kontrol ediniz.', {
                  title: 'DİKKAT!',
                  variant: 'dark',
                  solid: true
              })
              this.openModal(true, 'untrack', { ...data, type: 'untrack' });

            }
            return rej()            
          } else { rej() }
        })
      })
    },
    async addImage() {
      if(this.$refs.File.formData.image_file){
        this.$refs.File.$refs.Form.validate().then(async success => {
          if (success) {
            let data = prepareRequestData(this.faultImgForm,this.$refs.File.formData)
            data.id = this.faultSupport.id
            await this.$store.dispatch('faultsupports_image', data)
            if(this.status.status == 'Success') {
              return this.$router.push('/Stock/FaultSupports')
            }
          }
        })
      } else {
        this.$router.push('/Stock/FaultSupports')
      }
      
    }
  }
}
</script>

<style>
    @import "./styles/add.min.css"; 

</style>


// WEBPACK FOOTER //
// src/pages/ERP/Stock/FaultSupportsAdd.vue